import React from "react";
import { Overlay, Popover } from "react-bootstrap";

const TFUOverlay = ({ show, target, placement, container, title, content }) => {
    return (
        <Overlay show={show} target={target} placement={placement} container={container} containerPadding={20}>
            <Popover
                id="popover-basic"
                style={{
                    width: `400px`,
                    maxWidth: `400px`,
                }}
            >
                {title && <Popover.Title as="h3">{title}</Popover.Title>}
                <Popover.Content
                    style={{
                        width: `400px`,
                    }}
                >
                    {content && content()}
                </Popover.Content>
            </Popover>
        </Overlay>
    );
};

export default TFUOverlay;
